(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rhinoCartInit) return;
    window.__rhinoCartInit = true;

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ADD_URL = ROOT + 'cart/add.js';
    var CART_URL = ROOT + 'cart.js';

    /* Keeps the header bag count in sync (e.g. after removing items inside the drawer) */
    function refreshCartCount() {
      fetch(CART_URL, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-rc-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count < 1;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.cart-drawer__dialog')) {
        setTimeout(refreshCartCount, 900);
      }
    });

    function getDrawer() {
      return (
        document.querySelector('.site-header cart-drawer-component') ||
        document.querySelector('cart-drawer-component')
      );
    }

    function getDialog() {
      var drawer = getDrawer();
      return drawer ? drawer.querySelector('dialog') : null;
    }

    /* Native fallback: opens/closes the <dialog> directly, no theme JS needed */
    function forceOpen() {
      var dialog = getDialog();
      if (!dialog || dialog.open) return;
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
      dialog.addEventListener(
        'close',
        function () {
          document.body.style.overflow = '';
        },
        { once: true }
      );
    }

    function forceClose() {
      var dialog = getDialog();
      if (!dialog || !dialog.open) return;
      try {
        dialog.close();
      } catch (e) {
        dialog.removeAttribute('open');
      }
      document.body.style.overflow = '';
    }

    function openDrawer() {
      var drawer = getDrawer();
      if (!drawer) return;
      try {
        if (typeof drawer.open === 'function') drawer.open();
      } catch (e) {
        console.warn('[cart-drawer] theme open() failed, using fallback', e);
      }
      setTimeout(forceOpen, 350);
    }

    function reloadWithDrawer() {
      try { sessionStorage.setItem('reopen-cart-drawer', '1'); } catch (e) {}
      window.location.reload();
    }

    function addToCart(body, onError) {
      return fetch(ADD_URL, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body,
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(
              (result.json && (result.json.description || result.json.message)) || 'Could not add to cart'
            );
          }
          reloadWithDrawer();
        })
        .catch(function (error) {
          onError(error);
        });
    }

    /* Takes over add-to-cart on every product form so the theme never redirects to /cart */
    function handleAdd(form, event) {
      if (!form) return false;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return false;
      if (!getDrawer()) return false;

      var data = new FormData(form);
      if (!data.get('id')) return false;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.rhinoAdding === '1') return true;
      form.dataset.rhinoAdding = '1';

      addToCart(data, function (error) {
        form.dataset.rhinoAdding = '0';
        window.alert(error.message);
      });
      return true;
    }

    window.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('button, input[type="submit"]');
        if (!button) return;
        var type = (button.getAttribute('type') || 'submit').toLowerCase();
        if (type !== 'submit') return;
        handleAdd(button.form || button.closest('form'), event);
      },
      true
    );

    window.addEventListener(
      'submit',
      function (event) {
        handleAdd(event.target, event);
      },
      true
    );

    /* Fallbacks: header bag icon, close button, backdrop click */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('cart-drawer-component > button')) {
        setTimeout(forceOpen, 350);
        return;
      }

      if (target.closest('.cart-drawer__close-button')) {
        setTimeout(forceClose, 500);
        return;
      }

      if (target.tagName === 'DIALOG' && target.classList.contains('cart-drawer__dialog')) {
        setTimeout(forceClose, 500);
      }
    });

    /* Best sellers "Add to cart" buttons inside the drawer */
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-upsell-add]');
      if (!button) return;

      button.disabled = true;
      button.textContent = 'Adding...';

      var body = new FormData();
      body.append('id', button.dataset.variantId);
      body.append('quantity', '1');

      addToCart(body, function () {
        button.disabled = false;
        button.textContent = 'Add to cart';
      });
    });

    /* After the reload, open the drawer (never waits forever) */
    function reopenIfNeeded() {
      var reopen = false;
      try {
        reopen = sessionStorage.getItem('reopen-cart-drawer') === '1';
        sessionStorage.removeItem('reopen-cart-drawer');
      } catch (e) {}
      if (!reopen) return;

      var fired = false;
      function go() {
        if (fired) return;
        fired = true;
        openDrawer();
      }

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-drawer-component').then(function () {
          setTimeout(go, 300);
        });
      }
      setTimeout(go, 2000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reopenIfNeeded);
    } else {
      reopenIfNeeded();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
